import React from 'react';
import {injectIntl} from 'react-intl';
import TextField from '@FormComponents/TextField';
import EmailFieldValidated from '@FormComponents/EmailFieldValidated';
import SelectField from '@FormComponents/SelectField';
import LocationAutoSuggest from '@FormComponents/LocationAutoSuggest';
import TextArea from '@FormComponents/TextArea';
import CheckboxField from '@FormComponents/CheckboxField';
import PhoneField from '@FormComponents/PhoneField';
import ZipCode from '@FormComponents/ZipCode';

const FormField = ({intl, field, state, setState, errors, setErrors, onChange}) => {
  if (!field) {
    return '';
  }
  const {name, type, title, placeholder, required = true, options} = field;
  let intlError = '';
  if (errors[name] && type !== 'email') {
    intlError = intl.formatMessage({id: errors[name]});
  }
  const renderField = () => {
    let element = '';
    const mapping = {
      'text': TextField,
      'email': EmailFieldValidated,
      'pick': SelectField,
      'location': LocationAutoSuggest,
      'textarea': TextArea,
      'checkbox': CheckboxField,
      'phone': PhoneField,
      'zipcode': ZipCode,
    };
    const Component = mapping[type] ? mapping[type] : '';
    let settings = {
      name,
      placeholder,
      label: title,
      errors: errors[name] ? errors : {},
      required,
    };
    if (Component) {
      switch (type) {
        case 'pick':
          settings = {
            options,
            state,
            ...settings,
          };

          element = (
            <Component settings={settings} onChange={onChange} />
          );
          break;
        case 'location':
        case 'textarea':
          settings = {
            state,
            setState,
            ...settings,
          };

          element = (
            <Component settings={settings} onChange={onChange} />
          );
          break;
        case 'checkbox':
          element = (
            <div className={`form-group form-group__input--checkbox ${errors[name] ? 'form-group--error' : ''}`} >
              <label className="selection-control selection-control--checkbox">
                <span className="selection-control__input">
                  <Component name={name} label={settings.label} required={required} checked={state && state[name] ? state[name] : false} onChange={onChange} />
                  <span className="icon selection-control__control" aria-hidden={true}>
                    <svg viewBox="0 0 16 16">
                      <polyline points="2.1,8.5 6.2,12.4 13.9,5.1"/>
                    </svg>
                  </span>
                </span>
                <span className="selection-control__label">
                  {intl.formatMessage({id: title})}
                </span>
              </label>
              {errors[name] && <div className="form-group__feedback">{ intlError }</div>}
            </div>
          );
          break;
        case 'email':
          settings = {
            ...settings,
            state,
            errors,
            setErrors,
          };
          element = (
            <Component onChange={onChange} settings={settings}/>
          );
          break;
        case 'phone':
          element = (
            <Component settings={{
              ...settings,
              setState,
            }}/>
          );
          break;
        default:
          settings = {
            state,
            setState,
            ...settings,
          };
          element = (
            <div className={`form-group form-group--${name} ${errors[name] ? 'form-group--error' : ''}`} >
              <label className="form-group__label" htmlFor={name}>
                {intl.formatMessage({id: title})}
              </label>
              <Component
                name={name}
                placeholder={placeholder && intl.formatMessage({id: placeholder}).toLowerCase()}
                required={required}
                onChange={onChange}
                value={state && state[name] ? state[name] : ''}
                settings={settings}
              />
              {errors[name] && <div className="form-group__feedback">{intlError}</div>}
            </div>
          );
          break;
      }
    }
    return element;
  };

  return (
    <>
      {renderField()}
    </>
  );
};

export default injectIntl(FormField);
